import { render, staticRenderFns } from "./PriceCombo.vue?vue&type=template&id=ace22148&scoped=true"
import script from "./PriceCombo.vue?vue&type=script&lang=js"
export * from "./PriceCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace22148",
  null
  
)

export default component.exports